import { render } from "./ConfirmSaveDialog.vue?vue&type=template&id=0289b177"
import script from "./ConfirmSaveDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmSaveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__